import * as React from 'react';
import Arrows from '../Arrows';
import { RetrievalResult } from '../../types';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import CurrentResult from './CurrentResultMessage';

const IVF = (props: RetrievalResult) => {
  const { eggsRetrieved, normallyFertilized, embryosFrozen, attemptCompleted } = props;

  const resultsPending =
    !eggsRetrieved && !normallyFertilized && !embryosFrozen && !attemptCompleted;

  return (
    <>
      <h1>Details of retrieval & fertilization</h1>
      {!attemptCompleted && <CurrentResult />}
      {resultsPending ? (
        <Text>Pending</Text>
      ) : (
        <div>
          {!eggsRetrieved && !attemptCompleted ? null : (
            <p>
              <strong>{eggsRetrieved}</strong>
              <span>eggs retrieved</span>
            </p>
          )}
          {!normallyFertilized && !attemptCompleted ? null : (
            <span>
              <Arrows />
              <p>
                <strong>{normallyFertilized}</strong>
                <span>normally fertilized</span>
              </p>
            </span>
          )}
          {!embryosFrozen && !attemptCompleted ? null : (
            <span>
              <Arrows />
              <p>
                <strong>{embryosFrozen}</strong>
                <span>embryos frozen</span>
              </p>
            </span>
          )}
        </div>
      )}
    </>
  );
};

const Text = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-weight: bolder;
  font-size: 24px;
`;

export default IVF;
